import { Component, OnInit, Input } from '@angular/core';
import {SelectionModel} from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { ITableCheckBox } from "../../models/ITableCheckBox";

@Component({
  selector: 'ff-checkbox-table',
  templateUrl: './checkbox-table.component.html',
  styleUrls: ['./checkbox-table.component.scss']
})
export class CheckboxTableComponent implements OnInit {

  @Input() checkboxTableData: ITableCheckBox[];
  
  //Initialize elements with empty data
  displayedColumns: string[];
  dataSource = new MatTableDataSource<ITableCheckBox>();
  selection = new SelectionModel<ITableCheckBox>();

  ngOnInit(): void {
    this.displayedColumns = ['select', 'columnOne', 'columnTwo', 'columnThree', 'columnFour'];
    this.dataSource = new MatTableDataSource<ITableCheckBox>([...this.checkboxTableData]);
    this.selection = new SelectionModel<ITableCheckBox>(true, []);
  }

}
